import { render, staticRenderFns } from "./ShipmentPageStats.vue?vue&type=template&id=565dc770&scoped=true"
import script from "./ShipmentPageStats.vue?vue&type=script&lang=js"
export * from "./ShipmentPageStats.vue?vue&type=script&lang=js"
import style0 from "./ShipmentPageStats.vue?vue&type=style&index=0&id=565dc770&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565dc770",
  null
  
)

export default component.exports